import { get } from 'lodash';
import { success, error } from 'redux-saga-requests';
import { all, takeEvery } from 'redux-saga/effects';
import { toast } from 'src/components';
import { ROUTES } from 'src/constants';
import * as ActionTypes from './actionTypes';

export function signInWorker() {
  toast.dismiss();
}

export function signUpEmployerSuccessWorker() {
  window.location.href = ROUTES.signUpSuccess;
}

export function forgotPasswordSuccessWorker() {
  window.location.href = ROUTES.home;
}

export function resetPasswordSuccessWorker(action) {
  window.location.href = get(action, 'payload.redirect_to', '/profile/preferences');
}

export function redirectWorker({ payload }) {
  window.location.href = payload.redirect_to;
}
function signUpErrorWorker({ payload }) {
  console.error(payload);
}

export default function* userSaga() {
  yield all([
    yield takeEvery(ActionTypes.USER_SIGN_IN, signInWorker),
    yield takeEvery(success(ActionTypes.EMPLOYER_SIGN_UP), signUpEmployerSuccessWorker),
    yield takeEvery(success(ActionTypes.FORGOT_PASSWORD), forgotPasswordSuccessWorker),
    yield takeEvery(success(ActionTypes.RESET_PASSWORD), resetPasswordSuccessWorker),
    yield takeEvery(
      [error(ActionTypes.USER_SIGN_IN), error(ActionTypes.EMPLOYER_SIGN_UP), error(ActionTypes.CANDIDATE_SIGN_UP)],
      signUpErrorWorker
    ),
    yield takeEvery(
      [
        success(ActionTypes.USER_SIGN_IN),
        success(ActionTypes.EMPLOYER_SIGN_UP),
        success(ActionTypes.CANDIDATE_SIGN_UP)
      ],
      redirectWorker
    )
  ]);
}
